import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/config';
import { SessionProvider } from './context/SessionContext';
import { OnboardingProvider } from './context/OnboardingContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SessionProvider>
      <I18nextProvider i18n={i18n}>
        <OnboardingProvider>
        <App />
        </OnboardingProvider>
      </I18nextProvider>
    </SessionProvider>
  </React.StrictMode>
);

reportWebVitals();
